module.exports = __webpack_public_path__ + "static/media/mase.0debfeaf.m4a";